import { update } from '@intercom/messenger-js-sdk';
import { useMediaQuery } from '@material-ui/core';
import { useEffect, useState } from 'react';
import theme from 'theme';

const FORCE_HIDE_INTERCOM_KEY = '__forceHideIntercomLauncher';

export default function useHideWebWidget(hide = false) {
  const [widgetHidden, setWidgetHidden] = useState(false);
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('md'));
  const alwaysHiddenOnPages = ['messages', 'bookings'];

  const alwaysOnPages = () => {
    if (window.location.pathname === '/') return true;
    if (window.location.pathname.includes('host')) return true;
    if (window.location.pathname.includes('car-host')) return true;
    return false;
  };

  const hideInMobile = () => (isTabletOrMobile ? !alwaysOnPages() : false);
  const alwaysHidden = () => alwaysHiddenOnPages.some((p) => window.location.pathname.includes(p));
  const forceHidden = () => Boolean(window[FORCE_HIDE_INTERCOM_KEY]);

  useEffect(() => {
    if (hide || hideInMobile() || alwaysHidden() || forceHidden()) {
      setWidgetHidden(true);
      update({ hide_default_launcher: true });
    }

    return () => {
      if (widgetHidden && !hideInMobile() && !alwaysHidden() && !forceHidden()) {
        update({ hide_default_launcher: false });
      }
    };
  }, [hide, widgetHidden, window.location.path]);
}
